<template>
  <div class="custom-arrow">
    <img :src="`/static/img/arrows/arrow_${dir}_black.svg`"/>
  </div>
</template>

<script>
export default {
  name: 'CarouselArrow',
  props: {
    dir: {
      type: String,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CarouselArrow.vue